'use strict';
/**
 * @author Maxim Seredkin
 */
export default [
  '$resource',
  function ($resource) {
    return $resource('api/users/:userId', null, {
      get: { method: 'GET' },
      create: { method: 'POST' },
      update: { method: 'PUT' },
      remove: { method: 'DELETE' },
      enable: { url: 'api/users/:userId/enable', method: 'PUT' },
      disable: { url: 'api/users/:userId/disable', method: 'PUT' },
      delete: { url: 'api/users/:userId/delete', method: 'PUT' },
      recovery: { url: 'api/users/:userId/recovery', method: 'PUT' },
      getDefault: { url: 'api/users/default', method: 'GET' },
      setDefault: { url: 'api/users/:userId/default', method: 'PUT' },
      isUniqueLogin: { url: 'api/users/unique/login/:login', method: 'GET' },
      me: { url: 'api/users/me', method: 'GET' },
      count: { url: 'api/users/count', method: 'GET' },
      changePassword: { url: 'api/users/me/change-password', method: 'PUT' },
      notification: { url: 'api/notification', method: 'GET' },
    });
  },
];
